import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;

  svg {
    font-size: 12px;
  }
`;
